import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchEs = () => {
    return <AdvancedSearch languageCode="es" />
}

export default AdvancedSearchEs
